<app-help-page mainVideo="daily-notifications"
               [tutorials]="['daily-notifications', 'real-time-notifications']"
               [videos]="['daily-notifications', 'ga-real-time-notifications']"></app-help-page>
